import PazienteTerapia from "../";

const routes = [
    { name: "PazienteTerapiaList", path: "/paziente/terapia", component: PazienteTerapia.PazienteTerapiaList, meta: { title: "therapy.lblTitle" } },
    { name: "PazienteTerapiaView", path: "/paziente/terapia/view/:id", component: PazienteTerapia.PazienteTerapiaView, meta: { title: "therapy.lblTitle" } },
    { name: "PazienteTerapiaEdit", path: "/paziente/terapia/edit/:id", component: PazienteTerapia.PazienteTerapiaEdit, meta: { title: "therapy.lblTitle" } },
];

export default routes;
